import React from 'react';
import { ErrorWrapper } from '../../../components';
export const TableCell = ({ name, meta, children, }) => (React.createElement(ErrorWrapper, { name: name, meta: meta }, children));
